export function footer() {
  const footer: HTMLDivElement | null = document.querySelector(".stina-footer");
  const lastGroupEl: HTMLDivElement | null = document.querySelector(
    "main > .wp-block-group:last-child"
  );
  if (footer && lastGroupEl) {
    footer.style.backgroundColor =
      getComputedStyle(lastGroupEl)?.backgroundColor;
  }
}
